<template>
  <div>
    <div class="button hover" @click="handleClick"  >
      {{name}}
    </div>
  </div>
</template>

<script>
export default {
  name: "Button",
  props:['name'],
  methods: {
    handleClick(){
      this.$emit('handleClick')
    }
  }

}
</script>

<style scoped lang="less">
.button{
  border-radius: 16px;
  text-align: center;
  line-height: 32px;
  font-size: 16px;
  cursor: pointer;
  background: #ECF8FE;
  color: #1EA2EE;
  border: 1px solid #76C6F4;
  display: inline-block;
  padding: 0 20px;
}
.hover{
  cursor: pointer;
  &:hover{
    background: #099BEF !important;
    color: #fff !important;
  }
}
</style>